// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__26ws2","content":"LayoutSettings_content__up-H7"};